import { Config } from '@modules/common/types/config';

const parseBoolean = (value: string | boolean | undefined): boolean =>
  typeof value === 'boolean' ? value : value === 'true';

export const getConfig = (): Config => {
  // pls fix me
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const config = (window as any).globalConfig;

  return {
    api: {
      floorPlanService: {
        url: config.REACT_APP_FLOOR_PLAN_SERVICE_API,
        scope: config.REACT_APP_DIGITALTWIN_API_SCOPE,
      },
      floorplan: {
        url: config.REACT_APP_FLOORPLAN_API,
        scope: config.REACT_APP_FLOORPLAN_API_SCOPE,
      },
      project: {
        url: config.REACT_APP_PROJECT_API,
        scope: config.REACT_APP_PROJECT_API_SCOPE,
      },
      pimService: {
        url: config.REACT_APP_PIM_SERVICE_API,
        scope: config.REACT_APP_PIM_SERVICE_API_SCOPE,
      },
      simulation: {
        url: config.REACT_APP_SIMULATION_API,
        scope: config.REACT_APP_SIMULATION_API_SCOPE,
      },
      userPreferences: {
        url: config.REACT_APP_USER_PREFERENCES_SERVICE_API,
        scope: config.REACT_APP_USER_PREFERENCES_SERVICE_API_SCOPE,
      },
      viking: {
        url: config.REACT_APP_VIKING_API,
        scope: config.REACT_APP_VIKING_API_SCOPE,
      },
      fileService: {
        url: config.REACT_APP_FILE_SERVICE_API,
        scope: config.REACT_APP_FILE_SERVICE_API_SCOPE,
      },
      templateService: {
        url: config.REACT_APP_TEMPLATE_SERVICE_API,
        scope: config.REACT_APP_TEMPLATE_SERVICE_API_SCOPE,
      },
      errorMessageService: {
        url: config.REACT_APP_ERROR_MESSAGE_SERVICE_API,
        scope: config.REACT_APP_ERROR_MESSAGE_SERVICE_API_SCOPE,
      },
    },

    app: {
      version: config.REACT_APP_VERSION,
      env: config.REACT_APP_ENVIRONMENT,
      showDebugMenu: parseBoolean(config.REACT_APP_SHOW_DEBUG_MENU),
      showDebugProjectView: parseBoolean(config.REACT_APP_SHOW_DEBUG_PROJECT_VIEW),
    },

    auth: {
      clientId: config.REACT_APP_OPEN_ID_CLIENT_ID,
      authority: config.REACT_APP_OPEN_ID_AUTHORITY,
    },

    aps: {
      enabled: config.REACT_APP_APS_ENABLED,
      bucketKey: config.REACT_APP_APS_BUCKET_KEY?.toLowerCase(),
      modelDerivativeApi: config.REACT_APP_APS_MODEL_DERIVATIVE_API,
      ossApi: config.REACT_APP_APS_OSS_API,
      authApi: config.REACT_APP_APS_AUTH_API,
      authApiScope: config.REACT_APP_APS_AUTH_API_SCOPE,
    },

    azure: {
      insightsConnectionString: config.REACT_APP_INSIGHTS_CONNECTION_STRING,
      insightsInstrumentationKey: config.REACT_APP_INSIGHTS_INSTRUMENTATION_KEY,
    },

    portal: {
      url: config.REACT_APP_PORTAL_URL,
    },

    fleetTracker: {
      gatewayUrl: config.REACT_APP_FLEETTRACKER_GATEWAY,
      assetUrl: config.REACT_APP_FLEETTRACKER_ASSET_URL,
      webglUrl: config.REACT_APP_FLEETTRACKER_WEBGL_URL,
    },
  };
};

export const parseVersion = (value: string): number[] => {
  const splitValue = value.split('.');
  if (splitValue.length < 3) return [];

  const major = parseInt(splitValue[0], 10);
  const minor = parseInt(splitValue[1], 10);
  const patch = parseInt(splitValue[2], 10);
  if (Number.isNaN(major) || Number.isNaN(minor) || Number.isNaN(patch)) return [];

  return [major, minor, patch];
};

export const isOlderVersion = (value: string, reference: string): boolean => {
  const values = parseVersion(value);
  const references = parseVersion(reference);

  if (values.length < 3 || references.length < 3) return false;
  const [valueMajor, valueMinor, valuePatch] = values;
  const [referenceMajor, referenceMinor, referencePatch] = references;

  if (referenceMajor < valueMajor) return false;
  if (referenceMajor === valueMajor && referenceMinor < valueMinor) return false;
  if (
    referenceMajor === valueMajor &&
    referenceMinor === valueMinor &&
    referencePatch <= valuePatch
  )
    return false;

  return true;
};
